/* First-visit privacy notice. Deferred; never blocks rendering.
   - Loads Shopify's Customer Privacy API ('consent-tracking-api') and records the visitor's choice with setTrackingConsent
     (Accept = analytics/marketing/preferences true and sale_of_data false, Decline = all false), so Shopify-managed pixels follow it.
   - Hidden if consent was already chosen (currentVisitorConsent has any 'yes'/'no'), if a localStorage flag exists,
     or if Shopify's built-in cookie banner (#shopify-pc__banner) is on the page (only one banner at a time).
   - QA/testing: add ?bt_reset_consent=1 to any URL. It clears ONLY our own localStorage flag ('bt_privacy_choice') and forces the
     banner to show once on that page view (even if Shopify's consent cookie already holds a choice), then removes the param from
     the address bar. It never touches Shopify cookies; choosing Accept/Decline again simply re-records consent. Harmless in production.
   - Runs after window load + idle, so it never competes with rendering or LCP.
   - Fires document event 'bt:privacy-chosen' (and sets window.btPrivacyChosen) for the email popup gate.
   - Escape does nothing on purpose. Focus is only moved if it was inside the banner when it closes. */
(function () {
  var el = document.getElementById('bt-privacy');
  var KEY = 'bt_privacy_choice';
  function get() { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } }
  function put(v) { try { window.localStorage.setItem(KEY, v); } catch (e) { /* private mode */ } }
  function chosen(choice) {
    window.btPrivacyChosen = true;
    document.dispatchEvent(new CustomEvent('bt:privacy-chosen', { detail: { choice: choice || null } }));
  }
  if (!el) { return; }

  var force = false;
  try {
    var u = new URL(window.location.href);
    if (u.searchParams.get('bt_reset_consent') === '1') {
      force = true;
      try { window.localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
      u.searchParams.delete('bt_reset_consent');
      window.history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    }
  } catch (e) { /* old browser: ignore */ }

  function alreadyChosen(cp) {
    try {
      var c = cp.currentVisitorConsent() || {};
      return ['marketing', 'analytics', 'preferences', 'sale_of_data'].some(function (k) { return c[k] === 'yes' || c[k] === 'no'; });
    } catch (e) { return false; }
  }

  function show() {
    if (document.getElementById('shopify-pc__banner')) { return; } /* Shopify's own banner is active: don't stack a second one */
    el.hidden = false;
  }

  function hide() {
    var hadFocus = el.contains(document.activeElement);
    el.hidden = true;
    if (hadFocus) {
      var main = document.getElementById('MainContent');
      if (main) { main.focus({ preventScroll: true }); }
    }
  }

  function decide(value) {
    var yes = value === 'accept';
    var payload = { analytics: yes, marketing: yes, preferences: yes, sale_of_data: false };
    var done = false;
    function finish() {
      if (done) { return; }
      done = true;
      put(value);
      hide();
      chosen(value);
    }
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(payload, finish);
      window.setTimeout(finish, 1500); /* never leave the visitor stuck if the callback is slow */
    } catch (e) {
      finish();
    }
  }

  el.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bt-privacy]') : null;
    if (b) { decide(b.getAttribute('data-bt-privacy')); }
  });

  function start(cp) {
    document.addEventListener('visitorConsentCollected', function () { chosen(null); }); /* Shopify's own banner / other consent UI */
    if (!force && (get() || alreadyChosen(cp))) { chosen(get()); return; }
    window.setTimeout(show, 600); /* small delay so Shopify's own banner (if enabled) can mount first */
  }

  function withApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); return; }
    var tries = 0;
    (function wait() {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); }
        });
      } else if (tries++ < 40) {
        window.setTimeout(wait, 250);
      }
    })();
  }

  /* If the API never loads we show nothing (a banner that cannot record a choice would be misleading). */
  var run = function () { withApi(start); };
  var idleRun = function () { if ('requestIdleCallback' in window) { window.requestIdleCallback(run, { timeout: 3000 }); } else { window.setTimeout(run, 300); } };
  if (document.readyState === 'complete') { idleRun(); } else { window.addEventListener('load', idleRun, { once: true }); }
})();
